import { FC, useCallback } from "react";
import { Stack } from "@mui/material";
import { ColumnsInnerHeaderComponent } from "../../../common/ag-grid/components/ColumnsInnerHeaderComponent";
import { TypographyWithTooltip } from "../../../../common/TypographyWithTooltip";
import { useTotalInHeaderCalculator } from "../../../common/ag-grid/utils/hooks/useTotalInHeaderCalculator.hook";
import { readDataByDotSeparatedString } from "../../../common/ag-grid/utils/helpers/readDataByDotSeparatedString";
import type { CustomHeaderProps } from "ag-grid-react";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { getSavingsOpportunityName } from "@/components/pages/savings-opportunities/utils/helpers/getSavingsOpportunityName";

export const SavingsOpportunitiesInnerHeader: FC<CustomHeaderProps> = (
  props,
) => {
  const colId = props.column.getColId() as keyof SavingsOpportunity;
  const hideCountInHeader = props.context?.hideCountInHeader;

  const propItemReader = useCallback(
    (data: any) => readDataByDotSeparatedString(colId, data),
    [colId],
  );

  const total = useTotalInHeaderCalculator<SavingsOpportunity>(
    props.api,
    (colId as string) === "opportunity_name"
      ? opportunityNameItemReader
      : propItemReader,
    "uniquesCount",
  );

  if (!total || hideCountInHeader) {
    return <ColumnsInnerHeaderComponent {...props} />;
  }

  return (
    <Stack position="relative">
      <ColumnsInnerHeaderComponent {...props} />

      <TypographyWithTooltip title={total} variant="caption" fontSize={10} />
    </Stack>
  );
};

const opportunityNameItemReader = (data: any) =>
  getSavingsOpportunityName(data?.action_type, data?.service);
